module.exports = "/_next/static/files/23ac589539753e37e9135ecbf6dfc18b.jpg";